// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--dVsS6";
export var contact_us_page = "styles-module--contact_us_page--e9Fb+";
export var content = "styles-module--content--GiGz5";